import { render, staticRenderFns } from "./OrderAbnormal.vue?vue&type=template&id=540a0732&scoped=true&"
import script from "./OrderAbnormal.vue?vue&type=script&lang=js&"
export * from "./OrderAbnormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540a0732",
  null
  
)

export default component.exports